import React, { useEffect, useState } from "react";
import "../../assets/css/document-builder.scss";
import BoxButton from "../Delegations/BoxButton";

const FormBuilder = ({
  formCompleted,
  formId,
  formDataId,
  setDocBuilder,
  goToStep,
  setCurrentStep,
  currentStep,
  delegation,
  setErrorPopup,
}) => {
  const LAST_STEP_INDEX = 3;

  const done = (event) => {
    event.stopPropagation();
    setDocBuilder(event.detail[0].uuid);
    if (formCompleted) {
      formCompleted(event.detail[0].uuid);
    }
  };

  const scrollTopChangeStep = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = process.env.REACT_APP_DOCBUILDER_SDK_URL;
    script.async = false;
    script.setAttribute("data-name", "sdk-init");

    const container = document.getElementById("lexiaFormContainer");
    container.appendChild(script);

    let emailSetted = false;
    let phoneListenerAttached = false;

    const observer = new MutationObserver(() => {
      const nextButton = document.querySelector(".step-btn.step-next");
      const backButton = document.querySelector(".step-btn.step-back");

      if (nextButton) {
        nextButton.removeEventListener("click", scrollTopChangeStep);
        nextButton.addEventListener("click", scrollTopChangeStep);
      }
      if (backButton) {
        backButton.removeEventListener("click", scrollTopChangeStep);
        backButton.addEventListener("click", scrollTopChangeStep);
      }

      // BLOCCO EMAIL
      if (!emailSetted) {
        const emailInput = document.querySelector(
          'input[name="form_step_1_email"]',
        );
        if (emailInput) {
          emailInput.value = delegation.email;
          emailInput.readOnly = true;
          emailSetted = true;
        }
      }

      // BLOCCO TELEFONO: precompila e blocca la modifica
      const phoneInput = document.querySelector(
        ".form_step_1_phone input, input[name='form_step_1_phone']",
      );

      if (phoneInput) {
        phoneInput.setAttribute("type", "text");
        phoneInput.setAttribute("inputmode", "text");

        const rawPhone = (delegation.telephone || "").replace(/\+/g, "");
        phoneInput.value = rawPhone ? `+${rawPhone}` : "";

        phoneInput.readOnly = true;
      }

      // STEP CURRENT
      for (let i = 1; i <= 5; i++) {
        const stepDiv = document.querySelector(`.step-${i}`);
        if (stepDiv && stepDiv.classList.contains("active")) {
          setCurrentStep(i);
          break;
        }
      }

      // CATTURA ERROR SU VALIDAZIONE PER VISUALIZZARE POPUPERROR
      if (nextButton && !nextButton._validationAttached) {
        nextButton._validationAttached = true;

        nextButton.addEventListener("click", () => {
          setTimeout(() => {
            const errorFields = document.querySelectorAll(
              ".error, .invalid, .input-error, .validation-error",
            );

            if (errorFields.length > 0) {
              setErrorPopup(true);

              setTimeout(() => {
                setErrorPopup(false);
              }, 3000);
            }
          }, 50);
        });
      }

      // RADIO: radio "altro" obbligatorio
      const qualificaRadios = document.querySelectorAll(
        'input[name="form_step_1_qualifica"]',
      );

      const otherInput = document.querySelector(
        'input[name="form_step_1_qualificaOther"]',
      );

      if (qualificaRadios.length > 0 && otherInput) {
        const otherContainer = otherInput.parentNode;

        const applyQualificaValidation = () => {
          const selected = document.querySelector(
            'input[name="form_step_1_qualifica"]:checked',
          );

          if (!selected) return;

          if (selected.value === "altro") {
            otherInput.setAttribute("data-validate-required", "");

            if (!otherInput.value.trim()) {
              otherContainer.classList.add("validation-error");
            } else {
              otherContainer.classList.remove("validation-error");
            }
          } else {
            otherInput.removeAttribute("data-validate-required");
            otherContainer.classList.remove("validation-error");
          }
        };

        if (!window._qualificaListenerAttached) {
          window._qualificaListenerAttached = true;

          qualificaRadios.forEach((radio) =>
            radio.addEventListener("change", applyQualificaValidation),
          );

          otherInput.addEventListener("input", applyQualificaValidation);
        }

        applyQualificaValidation();
      }
    });

    if (container) {
      observer.observe(container, { childList: true, subtree: true });
    }

    document.addEventListener("lexiaFormSubmitted-" + formId, done, {
      once: true,
      capture: true,
    });

    return () => {
      if (document.body.contains(script)) {
        script.remove();
      }
      observer.disconnect();
    };
  }, [formId]);

  const simulateNextClick = () => {
    if (currentStep < LAST_STEP_INDEX) {
      setCurrentStep((prev) => prev + 1);
      const nextButton = document.querySelector(".step-btn.step-next");
      if (nextButton) nextButton.click();
    } else {
      const submitButton = document.querySelector(".step-submit");
      if (submitButton) submitButton.click();
    }
  };

  const simulateBackClick = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
      const backButton = document.querySelector(".step-btn.step-back");
      if (backButton) backButton.click();
    } else if (typeof goToStep === "function") {
      goToStep("STEP0");
    }
  };

  return (
    <div>
      <div
        className="lexiaFormContainer"
        data-form-id={formId}
        data-submission-id={formDataId}
        id="lexiaFormContainer"
      >
        Caricamento in corso...
      </div>

      <BoxButton
        onNext={simulateNextClick}
        delegation={delegation}
        onPrevious={
          // delegation.status === "REJECTED" && currentStep === 1
          //   ? null
          //   :
          simulateBackClick
        }
      />
    </div>
  );
};

export default FormBuilder;
